// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowURight16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-u-right': IconArrowURight;
    }
}

/**
 * The icon component for the 'arrowURight' icon
 */
export class IconArrowURight extends Icon {
    public constructor() {
        super(arrowURight16X16);
    }
}

registerIcon('icon-arrow-u-right', IconArrowURight);
export const iconArrowURightTag = 'nimble-icon-arrow-u-right';
